import React, { Fragment, useEffect, useState } from "react";
import { Prompt } from "react-router-dom";
import CustomPopUp from "../../components/global/CustomPopup";
import Button from "../../components/organism/Button";

interface RouteLeavingGuardProps {
  navigate: (path: string) => void;
  when: boolean;
  shouldBlockNavigation: (nextLocation: any) => boolean;
  title?: string;
  message?: string;
}

const RouteLeavingGuard: React.FC<RouteLeavingGuardProps> = ({
  navigate,
  when,
  shouldBlockNavigation,
  title = "Notification Settings",
  message = "The changes you've made may not be saved if you leave this page.",
}) => {
  const [modalVisible, updateModalVisible] = useState(false);
  const [lastLocation, updateLastLocation] = useState<any>();
  const [confirmedNavigation, updateConfirmedNavigation] = useState(false);

  const showModal = (location: any) => {
    updateModalVisible(true);
    updateLastLocation(location);
  };

  const closeModal = () => {
    updateModalVisible(false);
  };

  const handleBlockedNavigation = (nextLocation: any) => {
    if (!confirmedNavigation && shouldBlockNavigation(nextLocation)) {
      showModal(nextLocation);
      return false;
    }
    return true;
  };

  const handleConfirmNavigationClick = () => {
    closeModal();
    if (lastLocation) {
      updateConfirmedNavigation(true);
    }
  };

  useEffect(() => {
    if (confirmedNavigation) {
      navigate(lastLocation.pathname);
      updateConfirmedNavigation(false);
    }
  }, [confirmedNavigation]);

  return (
    <Fragment>
      <Prompt when={when} message={handleBlockedNavigation} />
      {modalVisible && (
        <CustomPopUp
          popUpTitle={title}
          routeLeaving={true}
          hidePopUp={closeModal}
        >
          <p className="mt-5 text-royalBlue items-start">{message}</p>
          <div className="flex items-end justify-end space-x-2 mt-2">
            <Button
              buttonTheme="secondary"
              textInformation={{
                text: `STAY`,
                fontWeight: "font-semibold",
              }}
              onClick={closeModal}
            />
            <Button
              buttonTheme="primary"
              textInformation={{
                text: `LEAVE`,
                fontWeight: "font-semibold",
              }}
              onClick={handleConfirmNavigationClick}
            />
          </div>
        </CustomPopUp>
      )}
    </Fragment>
  );
};

export default RouteLeavingGuard;
